export default {
	CREATE_DONE: 'WISH.CREATE.DONE',
	SET_WISHES_DONE: 'WISH.SET.DONE',
};



// WEBPACK FOOTER //
// ./src/actionTypes/wish.actionTypes.js